import { render, staticRenderFns } from "./duo_agents_platform_show.vue?vue&type=template&id=72f6290a"
import script from "./duo_agents_platform_show.vue?vue&type=script&lang=js"
export * from "./duo_agents_platform_show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports